import { useState, useEffect, useRef } from "react";
import { useProfile } from "../ProfileContext";
import "../styling/Header.css";
import { IoNotifications } from "react-icons/io5";
import CreateBookingModal from "./modals/CreateBookingModal";
import { useSelector } from "react-redux";
import data from "./data.json";
import { FaRegBuilding } from "react-icons/fa";
import { FaRegUser } from "react-icons/fa6";
import { FaRegCalendar } from "react-icons/fa";
import { MdOutlineLogout } from "react-icons/md";
import axios from "axios";
import { useContext } from "react";
import { EventDataContext } from "./EventDataContext";
import { FiMenu, FiX } from "react-icons/fi";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { FaTrash } from "react-icons/fa";
import defaultProfilePic from "../images/defaultPic.svg";

import { FaUserCircle } from "react-icons/fa";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";

const Header = ({
  onClickAccountInfo,
  onEventClick,
  handleClientClick,
  setSelectedMenuItem,
  setInitialBusinessEventTab,
  onToggleLeftMenu,     // new
  isLeftMenuOpen,  
  handleLogout
}) => {
  const navigate = useNavigate();

  const notificationIconRef = useRef(null);
  const notificationDropdownRef = useRef(null);
  const profileIconRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const deleteMenuRef = useRef(null);
  const searchContainerRef = useRef(null); // Ref for the entire search bar area


  const { EventData, setEventData } = useContext(EventDataContext);

  const [openDeleteMenu, setOpenDeleteMenu] = useState(null); // Stores the *index* of the open menu
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 }); // Stores click coordinates
  

  const { profileImage, setProfileImage } = useProfile();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showCreateDropdown, setShowCreateDropdown] = useState(false);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Clients");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [events, setEvents] = useState([]);
  useEffect(() => {
    // Add showSearchDropdown and searchQuery to the guard clause
    if (!showNotifications && !showProfileDropdown && !showSearchDropdown && !searchQuery && openDeleteMenu === null) {
      return;
    }
  
    const handleClickOutside = (event) => {
      // 1. Existing Profile logic
      const isClickInsideProfileIcon = profileIconRef.current?.contains(event.target);
      const isClickInsideProfileDropdown = profileDropdownRef.current?.contains(event.target);
      if (showProfileDropdown && !isClickInsideProfileIcon && !isClickInsideProfileDropdown) {
        setShowProfileDropdown(false);
      }
  
      // 2. Existing Notification/Delete logic
      const isClickInsideNotifIcon = notificationIconRef.current?.contains(event.target);
      const isClickInsideNotifDropdown = notificationDropdownRef.current?.contains(event.target);
      const isClickInsideDeleteMenu = deleteMenuRef.current?.contains(event.target);
      if ((showNotifications || openDeleteMenu !== null) && !isClickInsideNotifIcon && !isClickInsideNotifDropdown && !isClickInsideDeleteMenu) {
        setShowNotifications(false);
        setOpenDeleteMenu(null);
      }
  
      // 3. NEW: Search Bar Logic (Criteria + Results)
      const isClickInsideSearch = searchContainerRef.current?.contains(event.target);
      if (!isClickInsideSearch) {
        if (showSearchDropdown) setShowSearchDropdown(false);
        if (searchQuery) setSearchQuery(""); // Clears results when clicking away
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications, showProfileDropdown, showSearchDropdown, searchQuery, openDeleteMenu]);

  // Fetch notifications from the API
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business-user`,
        { withCredentials: true }
      );

      const newNotifications = response.data.data.notification || [];

      // Calculate unread notifications
      const unreadNotifications = newNotifications.filter(
        (n) => !n.isRead
      ).length;

      setNotifications(newNotifications);
      setUnreadCount(unreadNotifications);

    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business-user`,
        { withCredentials: true }
      );

      setProfileImage(response.data.data.profileImageUrl);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchNotifications();
  }, []);

  // Toggle notifications panel and fetch notifications
  const toggleNotifications = () => {
    setOpenDeleteMenu(null); 
    setShowNotifications((prev) => !prev);

    // Fetch notifications only when opening the panel
    if (!showNotifications) {
      fetchNotifications();
    }
  };

  const markAsRead = async (notificationId, index) => {
    const notification = notifications.find(n => n._id === notificationId);
    if (notification && notification.isRead) {
      return;
    }

    setNotifications(prevNotifications =>
      prevNotifications.map(n =>
        n._id === notificationId ? { ...n, isRead: true } : n
      )
    );
    setUnreadCount(prevCount => Math.max(0, prevCount - 1));

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/business-user/notification/read`,
        { notificationId },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // --- NEW: Delete Notification Function (adapted for business-user) ---
  const handleDeleteNotification = async (notificationId, index) => {
    const notification = notifications[index];
    
    setNotifications(prevNotifications =>
      prevNotifications.filter(n => n._id !== notificationId)
    );

    if (notification && !notification.isRead) {
      setUnreadCount(prevCount => Math.max(0, prevCount - 1));
    }
    
    setOpenDeleteMenu(null); // Close the menu

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/business-user/notification/delete`,
        { notificationId },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const toggleProfileDropdown = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const handleSearchBarChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchCriteria = () => {
    setSelectedItem((prevItem) =>
      prevItem === "Clients" ? "Events" : "Clients"
    );
    setShowSearchDropdown(false);
  };

  const toggleSearchDropdown = () => {
    setShowSearchDropdown(!showSearchDropdown);
  };

  const toggleCreateDropdown = () => {
    setShowCreateDropdown(!showCreateDropdown);
  };

  const handleItemClick = (type) => {
    toggleProfileDropdown();
    onClickAccountInfo(type);
  };

  const filterResults = (query) => {
    if (query) {
      const results =
        selectedItem === "Clients"
          ? data.clients.filter((client) =>
              client.toLowerCase().includes(query.toLowerCase())
            )
          : data.events.filter((event) =>
              event.name.toLowerCase().includes(query.toLowerCase())
            );
      setFilteredResults(results);
    } else {
      setFilteredResults([]);
    }
  };

  const openNewBookingsModal = () => {
    toggleCreateDropdown();
    setIsModalOpen(true);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // const handleBusinessUserLogout = async () => {
  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_API_URL}/business-user/logout`,
  //       {},
  //       { withCredentials: true }
  //     );
  //     navigate("/login");
  //   } catch (error) {
  //     console.error("Logout failed", error);
  //   }
  // };

  useEffect(() => {
    fetchClients();
    fetchEvents();
  }, []);

  useEffect(() => {
    handleFiltering();
  }, [searchQuery, selectedItem, clients, events]);

  const fetchClients = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/clients`,
        { withCredentials: true }
      );
      setClients(res.data.data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  const fetchEvents = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/events`,
        { withCredentials: true }
      );

      setEvents(res.data.data);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  const handleFiltering = () => {
    const query = searchQuery.toLowerCase();

    if (selectedItem === "Clients") {
      if (clients && clients.length > 0) {
        const filtered = clients.filter((client) =>
          client.name.toLowerCase().includes(query)
        );
        setFilteredResults(filtered);
      } else {
        setFilteredResults([]);
      }
    } else {
      if (events && events.length > 0) {
        const filtered = events.filter((event) =>
          event.eventName.toLowerCase().includes(query)
        );
        setFilteredResults(filtered);
      } else {
        setFilteredResults([]);
      }
    }
  };

  const handleNotificationClick = async (notification) => {
    if (!notification.isRead) {
      markAsRead(notification._id, null);
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/event/${notification?.eventId}`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        setEventData(response.data.data.event);
        onEventClick(EventData._id);
        setShowNotifications(false); // --- ADDED: Close tray on click ---
        setOpenDeleteMenu(null); // --- ADDED: Close delete menu ---

        if (notification?.title === "Booking Confirmation") {
          setInitialBusinessEventTab(0);

        } else if (
          notification?.title === "Reminder: Send Questionnaire" ||
          notification?.title === "Questionnaire Completed"
        ) {
          setInitialBusinessEventTab(3);
        } else if (
          notification?.title === "Reminder: Send Photostrip Template" ||
          notification?.title === "Photostrip Design Feedback Received"

        ) {
          setInitialBusinessEventTab(4);
        } else if (
          notification?.title === "Reminder: Upload Images to Gallery"
        ) {
          setInitialBusinessEventTab(5);
        }
      } else {
        console.error("Failed to fetch event data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  };

  return (
    <div>
      {isLoggedIn && (
        <header className="header" style={{ minHeight: "52px" }}>
          {/* LEFT SIDE */}
          <div className="header-left" style={{ display: "flex", width: "60%", marginTop: "-11px", alignItems: "center", gap: 0 }}>
            {/* Hamburger (mobile) */}
            <button
              className="btn-hamburger"
              aria-label="Toggle navigation"
              aria-controls="left-menu"
              aria-expanded={!!isLeftMenuOpen}
              onClick={onToggleLeftMenu}
              style={{ border: "none", background: "transparent", padding: 6, cursor: "pointer" }}
            >
              {isLeftMenuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
            </button>
 
            {/* Logo */}
            <img
              className="header-logo"
              style={{ marginLeft: "1%", width: "15%", cursor: 'pointer' }}
              src="https://cdn.prod.website-files.com/65997e123627c8e86f726abe/65a5db5cbf3e4af51b463bd7_Boothbloom-logo-color.svg"
              alt="BoothBloom"
              onClick={() => window.location.reload()}
            />
 
            {/* UNIFIED SEARCH BAR CONTAINER */}
            <div 
              ref= {searchContainerRef }
              className="nav-search-container" 
              style={{ 
                display: "flex", 
                alignItems: "center", 
                position: "relative", 
                marginTop: "13px", 
                marginLeft: "23px" 
              }}
            >
              {/* 1. THE DROPDOWN BUTTON WRAPPER */}
              <div style={{ position: "relative" }}>
                <button
                  className="header-search-btn"
                  onClick={toggleSearchDropdown}
                  style={{
                    fontSize: "15px",
                    border: "1px solid #D9D9D9",
                    height: "37px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    backgroundColor: "#FFFFFF",
                    cursor: "pointer",
                    borderRight: "none", // Join with input
                    borderRadius: "5px 0 0 5px", // Round left only
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    whiteSpace: "nowrap"
                  }}
                >
                  {selectedItem} <span>&#9662;</span>
                </button>

                {/* THE DROPDOWN MENU - Anchored to the button wrapper */}
                {showSearchDropdown && (
                  <div 
                    className="search-results"
                    style={{
                      position: "absolute",
                      top: "100%", // Exactly at the bottom of the button
                      left: 0,    // Flush with left edge
                      width: "100%", // Match button width exactly
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #D9D9D9",
                      boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                      marginTop: "2px",
                      zIndex: "10",
                      borderRadius: "5px",
                      overflow: "hidden" 
                    }}
                  >
                    <button
                      style={{
                        fontSize: "14px",
                        padding: "10px",
                        backgroundColor: "#FFFFFF",
                        cursor: "pointer",
                        border: "none",
                        width: "100%",
                        textAlign: "left"
                      }}
                      onClick={toggleSearchCriteria}
                    >
                      {selectedItem === "Clients" ? "Events" : "Clients"}
                    </button>
                  </div>
                )}
              </div>

              {/* 2. THE SEARCH INPUT BOX */}
              <div style={{ position: "relative", width: "250px" }}>
                <input
                  className="header-search-input"
                  type="text"
                  style={{ 
                    padding: "7.5px", 
                    paddingLeft: "33px", 
                    width: "100%", 
                    height: "37px", 
                    border: "1px solid #D9D9D9",
                    borderRadius: "0 5px 5px 0", // Round right only
                    boxSizing: "border-box" 
                  }}
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearchBarChange}
                />
 
                {searchQuery && (
                  <div
                    className="search-results"
                    style={{
                      position: "absolute",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #D9D9D9",
                      boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                      marginTop: "5px",
                      width: "100%",
                      zIndex: "10",
                      maxHeight: "200px",
                      overflowY: "auto",
                      borderRadius: "5px"
                    }}
                  >
                    {filteredResults.length > 0 ? (
                      filteredResults.map((result, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            if (selectedItem === "Events") {
                              onEventClick(result._id);
                              setEventData(result);
                            } else if (selectedItem === "Clients") {
                              handleClientClick(result);
                              setSelectedClient(result._id);
                              setSelectedMenuItem("Clients");
                            }
                            setSearchQuery("");
                            setFilteredResults([]);
                          }}
                          style={{ padding: "10px", cursor: "pointer", color: "#1C1154" }}
                        >
                          {selectedItem === "Clients" ? (
                            <div>{result.name}</div>
                          ) : (
                            <>
                              <div>{result.eventName}</div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  paddingTop: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                <div>
                                  <span style={{ color: "#625C73" }}>
                                    {new Date(result.eventDate).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric",
                                    })}
                                  </span>{" "}
                                  -{" "}
                                  <span style={{ color: "#2A1980", fontWeight: "bold" }}>{result.clientName}</span>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "10px" }}>No results found</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
 
          {/* RIGHT SIDE */}
          <div className="header-right" style={{ display: "flex", width: "17rem", alignItems: "center", position: "relative" }}>
            <div style={{ marginBottom: "3px", width: "10rem" }}>
              <button className="createButtonStyle" onClick={openNewBookingsModal}>
                + Create New
              </button>
            </div>
 
            <div className="notification" ref={notificationIconRef} onClick={toggleNotifications} style={{ position: "relative", cursor: "pointer" }}>
              <IoNotifications style={{ fontSize: "25px", color: "rgb(29,16,83)" }} />
              {unreadCount > 0 && (
                <span
                  className="badge"
                  style={{
                    position: "absolute",
                    top: "-4px",
                    right: "17px",
                    backgroundColor: "red",
                    padding: "0.5px",
                    color: "white",
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {unreadCount}
                </span>
              )}
            </div>
 
            <div className="profile" ref={profileIconRef} onClick={toggleProfileDropdown} style={{ marginBottom: "6px" }}>
            <img 
                src={profileImage || defaultProfilePic} 
                alt="Profile" 
                style={{ marginBottom: "6px", width: "38px", height: "38px", borderRadius: "50%", objectFit: "cover" }} 
                onError={(e) => { e.target.src = defaultProfilePic; }}
              />
            </div>
 
            <CreateBookingModal isModalOpen={isModalOpen} closeModal={closeModal} />
          </div>
 
          {/* NOTIFICATIONS PANEL */}
          {showNotifications && (
            <div ref={notificationDropdownRef} className="notification-layover">
              <div className="notification-title">
                <h2>Notifications</h2>
                <hr />
              </div>
              {notifications.length > 0 ? (
                notifications.map((notification, index) => (
                  <div
                    key={notification._id}
                    className={`notification-item ${notification.isRead ? "" : "unread"}`}
                    onMouseEnter={() => markAsRead(notification._id, index)} // --- ADDED ---
                    style={{ position: "relative" }} 
                  >
                    <div 
                      onClick={() => handleNotificationClick(notification)} 
                      style={{ cursor: "pointer" }}
                    >
                      <h4>{notification.title}</h4>
                      <p>{notification.message}</p>
                      <span className="timestamp">
                        {new Date(notification.timestamp).toLocaleString()}
                      </span>
                    </div>
                    
                    {/* --- NEW: Three dots menu --- */}
                    <div 
                      className="notification-dots"
                      onClick={(e) => {
                        e.stopPropagation(); 
                        if (openDeleteMenu === index) {
                          setOpenDeleteMenu(null);
                        } else {
                          const rect = e.currentTarget.getBoundingClientRect();
                          setMenuPosition({
                            top: rect.bottom - 10,
                            left: rect.left, 
                          });
                          setOpenDeleteMenu(index);
                        }
                      }}
                    >
                      <PiDotsThreeOutlineFill />
                    </div>
                  </div>
                ))
              ) : (
                <p className="no-notifications">No new notifications</p>
              )}
            </div>
          )}
 
          {/* PROFILE DROPDOWN */}
          {showProfileDropdown && (
            <div ref={profileDropdownRef} className="notification-layover" style={{ width: "11%", right: "2%", padding: "0px", display: "block" }}>
              <button
                className="profile-dropdown-item"
                style={{
                  border: "none",
                  borderBottom: "1px solid  #F1F1F3",
                  backgroundColor: "#FFFFFF",
                  display: "flow",
                  width: "100%",
                  paddingLeft: "20%",
                  textAlign: "left",
                }}
                onClick={() => handleItemClick("account")}
              >
                <FaRegUser /> Account
              </button>
 
              <button
                className="profile-dropdown-item"
                style={{
                  border: "none",
                  borderBottom: "1px solid  #F1F1F3",
                  backgroundColor: "#FFFFFF",
                  display: "flow",
                  width: "100%",
                  paddingLeft: "20%",
                  textAlign: "left",
                }}
                onClick={() => handleItemClick("company")}
              >
                <FaRegBuilding /> Company
              </button>
 
              <button
                className="profile-dropdown-item"
                style={{
                  border: "none",
                  borderBottom: "1px solid  #F1F1F3",
                  backgroundColor: "#FFFFFF",
                  display: "flow",
                  width: "100%",
                  paddingLeft: "20%",
                  textAlign: "left",
                }}
                onClick={() => handleItemClick("booth")}
              >
                <FaRegCalendar /> Book-A-Booth
              </button>
 
              <button
                className="profile-dropdown-item"
                style={{
                  border: "none",
                  borderBottom: "1px solid #F1F1F3",
                  backgroundColor: "#FFFFFF",
                  display: "flow",
                  width: "100%",
                  paddingLeft: "20%",
                  textAlign: "left",
                }}
                onClick={handleLogout}
              >
                <MdOutlineLogout /> Log Out
              </button>
            </div>
          )}
        </header>
      )}
      {showNotifications && openDeleteMenu !== null && (
        <div
          ref={deleteMenuRef}
          className="delete-dropdown"
          style={{
            position: 'fixed',
            top: `${menuPosition.top}px`,
            left: `${menuPosition.left}px`,
            zIndex: 1001,
          }}
        >
          <button
            className="delete-button"
            onClick={(e) => {
              e.stopPropagation();
              const notificationToDelete = notifications[openDeleteMenu];
              if (notificationToDelete) {
                handleDeleteNotification(notificationToDelete._id, openDeleteMenu);
              }
              setOpenDeleteMenu(null); 
            }}
          >
            <FaTrash /> Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
